import type { EmbargoRuleEvaluator } from '../types';
import { freezableLaneByTerminalRule, freezableLaneByZipRule } from './freezableLaneRule';
import { nonServiceZipRule } from './nonServiceZipRule';

/** Create / edit / bulk — all three client rules. */
export const EMBARGO_PICKUP_MANAGEMENT_RULES: EmbargoRuleEvaluator[] = [
  nonServiceZipRule,
  freezableLaneByZipRule,
  freezableLaneByTerminalRule,
];

/** Process pickup and driver app — zip rules only; freezable requires isFreezable. */
export const EMBARGO_PROCESS_RULES: EmbargoRuleEvaluator[] = [
  nonServiceZipRule,
  freezableLaneByZipRule,
];
